import { RouterProvider } from "react-router-dom";
import router from "./routes/router";
import { Suspense } from "react";
import ErrorBoundary from "./ErrorBoundary";
import Loading from "./components/ui/Loading";

function App() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loading fullScreen message="در حال بارگذاری صفحه..." size="lg" />}>
        <RouterProvider router={router} />
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;
